import { Component, ViewChild, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "app/auth/services/auth.service";

@Component({
    templateUrl: 'recover-password.component.html'
})
export class RecoverPasswordComponent implements OnInit {
    email: string;
    @ViewChild('recoverPasswordForm', { static: false }) recoverForm: NgForm;
    errors: string[];
    submitAttempt: boolean;
    constructor(private _router: Router, private _authService: AuthService) {
    }

    ngOnInit(): void {
        this.submitAttempt = false;
        var html = document.getElementsByTagName('html')[0];
        html.className = 'fixed dark';
    }

    recoverpassword(): void {
        this.submitAttempt = true;
        if (this.recoverForm.valid) {
            this._authService.recoverPassword(this.email).subscribe(response => {
            },
                error => {
                    this.errors = this._authService.identityErrorsToArray(error);
                });
        }
    }
    onHide(): void {
        this._router.navigate(['auth/login']);
    }
}
